<template>
  <div class="form-group centix-vue-datetimeinput row" :class="{ 'disabled' : !isEnabled }" v-show="isVisible">
      <form-label :label="label" :info="info" :labelCssClass="labelCssClass" :infoIconWrapper="infoIconWrapper"/>
      <span class="holder-span" :class="inputCssClass">
        <datetime-input 
          class="input-item"
          ref="datetimeInput" 
          v-model="localvalue" 
          @value-changed="valueChanged" 
          :is-enabled="isEnabled" 
          :required="required" 
          :show-year="showYear"
          :show-month="showMonth"
          :show-day="showDay"
          :show-hours="showHours"
          :show-minutes="showMinutes"
          :show-time="showTime"
          @on-return="onReturn"
          :double-click-date-now="doubleClickDateNow" />
        <a v-show="validDate && isEnabled" href="javascript:void(0);" @click.stop="clearForm" class="clear-button"></a>
      </span>
      <div class="model-state-error col-12">
        {{ validationError }}
      </div>
  </div>
</template>
<script>
import datetimeinput from 'components/Input/DateTimeInput.vue';
import FormMixin from './formitem.js';
import utils from 'libs/utils.js';

export default {
  mixins: [FormMixin],
  components: {
    'datetime-input': datetimeinput
  },
  props: {
    value: {
      required: true
    },
    required: {},
    showDay: {
      type: Boolean,
      default: true
    },
    showMonth: {
      type: Boolean,
      default: true
    },
    showYear: {
      type: Boolean,
      default: true
    },
    showHours: {
      type: Boolean,
      default: true
    },
    showMinutes: {
      type: Boolean,
      default: true
    },
    doubleClickDateNow: {
      type: Boolean,
      default: true
    },
    showTime: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      formType: 'datetime',
      localvalue: null
    };
  },
  mounted () {
    this.localvalue = this.value;
  },
  methods: {
    raiseValueChanged (val) {
      this.$emit('change', val);
      this.emitFormChange();
    },
    valueChanged (val) {
      this.$log('value changed from inner component', val);
      if (val !== this.value) {
        this.raiseValueChanged(val);
      }
    },
    clearForm() {
      this.raiseValueChanged('');
    }
  },
  computed: {
    showRequiredClass: function () {
      if (this.required && !this.hasValue) {
        return true;
      } else {
        return false;
      }
    },
    validDate() {
      return utils.isValidDate(this.value);
    }
  },
  watch: {
    value (newvalue, oldvalue) {
      this.localvalue = newvalue;
    }
  }
};
</script>
<style lang="scss" scoped>
@import 'styles/settings.scss';

.centix-vue-datetimeinput {
  span.holder-span {
    position: relative;
    display: block;
  }
  &:not(.disabled) {
    .input-item {
      &.required {
        border: 1px solid $error;
      }
      &.filled {
        padding-right: 25px;
        border: 2px solid #80bdff;
      }
    }
  }
  .clear-button {
    position: absolute;
    display: none;
    // right: 0;
    // top: 0;
    background: url('../../assets/remove.png') transparent no-repeat center right 16px;
    background-size: 12px 12px;
    width: 36px;
    height: 100%;
    cursor: pointer;
  }
  .model-state-error {
    color: $error;
  }
  &:hover {
    .clear-button {
      display: inline-block;
    }
  }
}
</style>
